/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { loadTourScript, TourData } from './slice';

export function TourLoader() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadTourScript());
    }, [dispatch]);

    return null;
}

export function TourLibraryMenu({
    eventKey,
    versions,
    handleStartVersion,
}: {
    eventKey: any;
    versions: TourData[];
    handleStartVersion: (id: string) => void;
}) {
    return (
        <NavDropdown
            title={
                <span>
                    <span className='caret caret-left' />
                    Update Tour Library
                </span>
            }
            id='navigation-tour-library-dropdown'
            className='navigation-dropdown dropdown-left'
        >
            {versions.map((version, index) => (
                <NavDropdown.Item
                    key={version.id}
                    eventKey={`${eventKey}.${index}`}
                    onSelect={() => handleStartVersion(version.id)}
                >
                    Update {version.id}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
}
